var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('dv-decoration-8',{staticStyle:{"width":"90px","height":"50px"},attrs:{"reverse":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }